// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3zaTv","label":"LabeledBox_label__21V8r"};